import React from 'react'
import { PreviewBody, PreviewFooter, PreviewLabel, PreviewLayout } from '../sub-components/PreviewLayout'
import LoadingList from '../skeletons/LoadingList'
import LoadingDiscountStrip from '../skeletons/LoadingDiscountStrip'
import { AddressPageType } from 'src/lib/types/uiPreview'
import PreviewBanner from '../sub-components/PreviewBanner'
import PreviewCTA from '../sub-components/PreviewCTA'
import LoadingAddressList from '../skeletons/LoadingAddressList'

const AddressPage: React.FC<AddressPageType> = ({
  addressBanner,
  addressButtonCTAText,
  addressCouponVisibility,
  colorPalette,
  deliveryInfoConfig
}) => {
  return (
    <PreviewLayout>
      <>
        <PreviewLabel>
          {addressBanner.enabled ? (
            <PreviewBanner
              backgroundColor={addressBanner.color ?? '#5a31f4'}
              textColor={addressBanner.textColor ?? '#FFFFFF'}
              bannerText={addressBanner.text ?? '(Enter some text to see a preview here)'}
            />
          ) : (
            <></>
          )}
        </PreviewLabel>
        <PreviewBody>
          <LoadingList
            length={1}
            skeleton={{
              layout: 'row',
              config: [
                { height: 1, width: 1 },
                { height: 1, width: 6 }
              ]
            }}
          />
          <LoadingDiscountStrip
            isHidden={!Boolean(addressCouponVisibility?.areCouponsVisible)}
            skeleton={{
              layout: 'row',
              justify: 'space-between',
              config: [
                {
                  layout: 'row',
                  config: [
                    { height: 1, width: 1 },
                    { height: 1, width: 6 }
                  ]
                },
                { height: 1, width: 1 }
              ]
            }}
            isCard={addressCouponVisibility?.visibilityExtent === 'cards'}
          />
          <LoadingAddressList
            borderColor={colorPalette?.primaryColor ?? '#5a31f4'}
            skeleton={{
              layout: 'column',
              config: [
                {
                  layout: 'row',
                  config: [
                    { height: 1, width: 1 },
                    { height: 1, width: 6 }
                  ]
                },
                { height: 4, width: 14 }
              ]
            }}
            deliveryText={deliveryInfoConfig.deliveryInfoText}
            isDeliveryTextEnabled={deliveryInfoConfig.isVisible}
            isETDEnabled={deliveryInfoConfig.isETDEnabled}
          />
        </PreviewBody>
        <PreviewFooter>
          <PreviewCTA
            color={colorPalette.primaryColor ?? '#5a31f4'}
            textColor={colorPalette.primaryTextColor ?? '#FFFFFF'}
            CTAText={addressButtonCTAText}
            isSecuredByTextEnabled={true}
            isAnchored={true}
          />
        </PreviewFooter>
      </>
    </PreviewLayout>
  )
}

export default AddressPage
